import { getToken, getRoles } from '@/utils/auth'; // getToken from cookie
import { API_URL } from '@/utils/request'
import env from '@/utils/env';

const BASE_URL = env.DEV ? '' : process.env.BASE_URL
export default {
  skin_url: `${BASE_URL}tinymce/skins/ui/oxide`,
  language_url: `${BASE_URL}tinymce/languages/zh_CN.js`,
  language: 'zh_CN',
  height: 500,
  toolbar_mode: 'wrap',
  content_style: `
    body { line-height: 1.68; font-size: 14px; } 
    img { display: block; margin-left: auto; margin-right: auto; max-width:100%; height: auto; }
  `,
  plugins: ['image', 'link', 'fullscreen'],
  images_upload_handler: function(blobInfo, success, failure) {
    var xhr, formData;
    xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', `${ API_URL }?do=picture_add`);
    xhr.onload = function() {
      var json;
      if (xhr.status != 200) {
        failure('HTTP Error: ' + xhr.status);
        return;
      }
      json = JSON.parse(xhr.responseText);
      if(json.error_code !== 0) {
        failure(json.error_message)        
        return
      }
      success(json.file);
    };
    formData = new FormData();
    formData.append('sid', getToken());
    formData.append('type', getRoles());
    formData.append('picture', blobInfo.blob());
    xhr.send(formData);
  },
  toolbar: [
    {
      name: 'history', items: ['undo', 'redo'],
    },
    {
      name: 'styles', items: ['styleselect'],
    },
    {
      name: 'fontsizeselect', items: ['fontsizeselect', 'lineheight'],
    },
    {
      name: 'color', items: ['forecolor', 'backcolor'],
    },
    {
      name: 'formatting', items: ['bold', 'italic'],
    },
    {
      name: 'alignment', items: ['alignleft', 'aligncenter', 'alignright', 'alignjustify'],
    },
    {
      name: 'indentation', items: ['outdent', 'indent'],
    },
    {
      name: 'media', items: ['image', 'link', 'fullscreen'],
    },
  ],
}